/**
 * This is a convenience component for the user account info menu. This is a
 * menu that generally has profile related links, such as logout and a link
 * directly to the user's profile self-management.
 */
import React from 'react';
import MenuItemFC from './MenuItemFC';
import AppHeaderStyles from './AppHeader.module.css';

const AccountInfoMenu = ({ menuItems }) => (
  <nav className={AppHeaderStyles.headerLinks} style={{ display: 'flex' }}>
    {menuItems.map((menuItem) => (
      <MenuItemFC
        key={`menu-item-key-${menuItem.displayText}`}
        className={AppHeaderStyles.menuItemAccountInfo}
        labelClassName=""
        linkClassName={AppHeaderStyles.accountInfoMenuItemLink}
        menuItem={menuItem}
        subMenuContainerClassName=""
        subMenuItemClassName=""
        subMenuLinkClassName=""
      />
    ))}
  </nav>
);
export default AccountInfoMenu;
